import { storageLocal } from '@/utils/storage.utils';

const APP_URL_IOS = import.meta.env.VITE_APP_URL_IOS || 'midle://';
const APP_URL_ANDROID = import.meta.env.VITE_APP_URL_ANDROID || 'midle://';
export const connection = {
  redirect: (navigate: (arg0: string) => void, page = '') => {
    const platform = storageLocal.getItem('platform') || '';
    storageLocal.removeItem('platform');
    if (page == '/' && (platform === 'ios' || platform === 'android')) {
      page += 'noauth';
    }
    if (platform === 'ios') {
      location.href = `${APP_URL_IOS}${page}/${storageLocal.getItem('refreshToken')}`;
      //navigate(`${APP_URL_IOS}${page}?token=${storageLocal.getItem('refreshToken')}`);
    } else if (platform === 'android') {
      location.href = `${APP_URL_ANDROID}${page}/${storageLocal.getItem('refreshToken')}`;
      //navigate(`${APP_URL_ANDROID}${page}?token=${storageLocal.getItem('refreshToken')}`);
    } else {
      navigate(`${page}`);
    }
  },
};
